
const API = {
  // 查询生效卡
  validCard: 'apps.coupon.validCard',
  // 我的卡券列表
  benefitQuery: 'apps.user.benefit.query',

  benefitItem: 'apps.user.benefit.item',

  benefitDefault: 'apps.user.benefit.default',

  personalCoupon: 'apps.coupon.personal',

  orderQuery: 'activity.order.query',

  orderDetail: 'activity.order.detail',

  busOrderList: 'apps.order.orders',

  couponOrderList: 'apps.order.coupon.orders',

  busOrderDetail: 'apps.order.order.detail',

  busCouponOrderDetail: 'apps.order.coupon.coupon.detail',

  deductOrder: 'apps.order.run.deductOrder',

  // 通过小程序sessionId换取sessionId
  loginS2S: "apps.user.login.s2s",
}
export {
  API
}
